import axios from 'axios';
import { API_HOST } from '../../../consts';

export const fetchTemplates = () => (
  axios.get(`${API_HOST}/export_item/templates`)
    .then(response => {

      const filteredTemplates = response.data.filter(template => (
        template.oculto !== true
      ));
      return filteredTemplates;
    })
);

export default fetchTemplates;
